import Api from './Api'
import { cdnPath } from './interface/Common'
import Model from './interface/Model'

export default class MediaProperty extends Model {
  protected api_settings = {
    save_mode: 'form',
    paths: {
      singular: 'media_property' as string | null,
      plural: 'media_properties' as string | null,
    },
  }

  public id: string = ''

  public name: string = ''

  public type: string = 'fep'

  public group_name: string = ''

  public has_logo: boolean = false

  public logo = {
    path: null as string | null,
    file: null as any,
  }

  public file: any = null

  public get apiData() {
    return {
      name: this.name,
      type: this.type,
      group_name: this.group_name,
      has_logo: !!(this.logo.path != null || this.logo.file != null),
      logo_file: this.logo.file,
    }
  }

  public toObject(source: any) {
    let instance = this.clone()

    Object.assign(instance, source)

    if (source.has_logo) {
      instance.logo = {
        path: `media_property/${source.id}.png`,
        file: null,
      }
    }

    return instance
  }

  public save() {
    const api = new Api()

    let data = this.apiData

    if (!this.logo.file) {
      delete data.logo_file
    }

    if (this.id) {
      return api.form(`media_property/${this.id}`, data).then(this.onSave).catch(this.onError)
    }
    return api.form('media_property', data).then(this.onSave).catch(this.onError)
  }
}
